import TagsPage, { TagsPageProps } from './TagsPage';

export type { TagsPageProps };
export default TagsPage;
